/*---

  Scripts for the product description section

  Louis-Charles Blais [info@22agencecreative.ca]

---*/


let descriptionPartsLabels = document.querySelectorAll('.product-description-container .head .label');
let descriptionPartsContents = document.querySelectorAll('.product-description-container .content .content-segment');

// function to switch
function switchDescriptionTab() {
  for (let i = 0; i < descriptionPartsLabels.length; i++) {
    descriptionPartsLabels[i].classList.remove('active');
  }
  event.target.classList.add('active');
  for (let i = 0; i < descriptionPartsContents.length; i++) {
    if (descriptionPartsContents[i].dataset.segment == event.target.dataset.segment) {
      descriptionPartsContents[i].classList.add('active');
    } else {
      descriptionPartsContents[i].classList.remove('active');
    }
  }
}

// initiate first tab
descriptionPartsLabels[0].classList.add('active');
descriptionPartsContents[0].classList.add('active');